<template>
  <div>
    <div class="page">
      <div class="loginPage">
        <div class="title">绑定手机号</div>
        <div class="dot"></div>
        <div class="item1" style="margin-bottom: 30px">
          <img
            class="ico"
            slot="prefix"
            style="width: 10px; height: 17px"
            src="@/assets/tel.png"
            alt=""
          />
          <select style="border: 0;width: 80px;padding: 0 10px;outline: none;" v-model="sms_code" id="">
            <option
                v-for="(item, index) in sms_code_list"
                :key="index"
                :value="item.code">
              +{{ item.code }}
            </option>
          </select>
          <input
            style="padding: 1px 15px"
            type="number"
            placeholder="请输入手机号"
            v-model="tel"
          />
        </div>
        <div class="item1" style="margin-bottom: 15px">
          <img
            class="ico"
            slot="prefix"
            style="width: 14px; height: 15px"
            src="@/assets/pass.png"
            alt=""
          />
          <input
            style="width: 120px; padding: 1px 12px"
            type="number"
            placeholder="请输入验证码"
            v-model.number="code"
          />
          <div class="second" @click="getPhoneCode">
            {{ start ? num + "s" : "点击获取验证码" }}
          </div>
        </div>


        <div
          class="item"
          style="text-align: center; margin-bottom: 50px"
          @click="bindingPhoneOpDo"
        >
          <el-button class="login">绑定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  bindingPhoneOne,
  bindingPhoneOneOp,
  smsCodeList
} from "@/request/api.js";
export default {
  data() {
    return {
      tel: "",
      code: "",
      start: false,
      num: 59,
      checked: false,
      sms_code_list: [],
      sms_code: "86",
    };
  },

  created() {
	document.title = '以图绘图印花设计网-绑定手机号';
    this.getSmsCode();
  },

  methods: {
    getSmsCode() {
      smsCodeList({}).then((res) => {
        this.sms_code_list = res.data;
      });
    },
    //获取验证码
    getPhoneCode() {
      if (this.start) {
        return;
      }
      bindingPhoneOne({
        tel: this.tel,
        code:this.sms_code,
      }).then((res) => {
        if (res.code == 200) {
          this.start = !this.start;
          var t = this.num;
          var time = setInterval(() => {
            this.num = t--;
            if (this.num == 0) {
              clearInterval(time);
              this.start = !this.start;
              this.num = 60;
            }
          }, 1000);
        }

        if (res.code == 500) {
          this.$message.error(res.msg);
        }
      });
    },
    //填写验证码确认
    bindingPhoneOpDo() {
      bindingPhoneOneOp({
        tel: this.tel,
        code: this.code,
        sms_code:this.sms_code,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          localStorage.setItem("is_binding", '1');
          this.$router.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    go(url) {
      this.$router.push({
        name: url,
      });
    },
  },
};
</script>

<style lang="less">
body {
  position: relative;
  background: url("../../assets/loginbeij.png") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  // margin-left: 8%;
}

.page {
  background-color: #ffffff;
  // border: 1px red solid;
  .loginPage {
    margin-top: 130px;
    padding: 22px 28px;
    .title {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #08243c;
      margin-bottom: ;
    }
    .dot {
      background-color: #e66617;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin: 8px 49% 30px;
    }
    .item {
      .agreement {
        font-size: 12px;
        font-weight: 400;
        color: #000000;
      }

      .login {
        width: 230px;
        height: 40px;
        background: #08243c;
        border-radius: 20px;
        font-size: 15px;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .item1 {
      display: flex;
      align-items: center;
      padding: 8px 9px;
      border-bottom: 1px solid #dfdfdf;
      input {
        background: none;
        outline: none;
        border: none;
      }
      .second {
        font-size: 12px;
        font-weight: 400;
        color: #e66617;
        cursor: pointer;
      }
    }
    .sanfang {
      font-size: 12px;
      font-weight: 400;
      color: #888888;
      line-height: 12px;
    }

    .wx {
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
